import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Tooltip } from 'antd';
import { DataTable, InfoMessage } from 'components';
import {
  columnsPillarAGreenTransitionsTable,
} from '../../config';
import { useSelector } from 'react-redux';
import merge from 'lodash/merge';
import keyBy from 'lodash/keyBy';
import filter from 'lodash/filter';
import cloneDeep from 'lodash/cloneDeep';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import { basicInfoSchema } from 'utils/beneficiaryColumns';
import { isEmpty } from 'lodash';
import { currencyFormatter, percentageFormatter } from 'utils';
// import { parseCurrency } from 'utils/helpers';

const SubTabPlan4 = () => {

  const excelData = useSelector(state => state.forms?.carrier?.dapanesEpendysis);
  const [businessPlanDetails, setBusinessPlanDetails] = useState("");
  const carrier = useSelector(state => state.forms.carrier);

  useEffect(()=>{
    if(excelData){
      setBusinessPlanDetails(JSON.parse(excelData));
    } else {
      setBusinessPlanDetails("");
    }
  },[excelData]);

  const pillarADatasource = merge(
    cloneDeep(
      keyBy(
        businessPlanDetails
          ? businessPlanDetails.proupologismosEpendytikouSxediou
          : [],
        'ependytikiDapani'
      )
    ),
  );

  // const pillarADatasource = cloneDeep(
  //   (businessPlanDetails?.proupologismosEpendytikouSxediou || []).filter(
  //     (item) => item.kostosAgoras !== 0
  //   )
  // );
 

   const columnsInvestmentTotalAmountTable = [
    {
      title : 'Χρηματοδοτικό Σχήμα Επένδυσης',
      dataIndex : 'title',
      key : 'title',
      align: 'left',
      width: 126,
    },
    {
      title: '% Συνεισφοράς',
      dataIndex : 'percentage',
      key: 'percentage',
      align: 'center',
      width: 126,
    },
    {
      title: 'Ποσό (€)',
      dataIndex : 'SumTotalExpense',
      key: 'SumTotalExpense',
      align: 'right',
      width: 126,
    },
  ]
  
   const testSelectedDataTable = [
       {
         title:"Ιδία Συμμετοχή/Ενισχύσεις", //totalEstimate
         percentage:percentageFormatter(carrier?.totalEstimatePercentage*100),
         SumTotalExpense : currencyFormatter(carrier?.totalEstimate)
       },
       {
         title:"Εμπορικό Δάνειο", //commercial loan
         percentage:percentageFormatter(carrier?.commercialLoanPercentage*100),
         SumTotalExpense : currencyFormatter(carrier?.commercialLoan)
       },
       {
         title:"Δάνειο ΤΑΑ", //loan
         percentage:percentageFormatter(carrier?.loanPercentage),
         SumTotalExpense : currencyFormatter(carrier?.loan)
       },
       {
         title:"Σύνολο", //totalbudget
         percentage:"100,00%",
         SumTotalExpense : currencyFormatter(carrier?.totalEstimate + carrier?.commercialLoan + carrier?.loan)
       },
         
     ] 

  let pillarAColumns = columnsPillarAGreenTransitionsTable;

  //TO BE TESTED->
  const filteredData = filter(pillarADatasource, function (value) {
    return (
      value?.hasOwnProperty('ependytikiDapani') &&
      value.ependytikiDapani !== ''
    );
  });
  
  const totalKostosAgoras = filteredData.reduce(
    (acc, curr) => acc + (parseFloat(curr.kostosAgoras) || 0),
    0
  );
  
  // Append summary row
  const dataSourceWithSummary = [
    ...filteredData.map((d, index) => ({
      ...d,
      key: index,
    })),
    {
      key: 'summary',
      ependytikiDapani: 'Σύνολο',
      perigrafiEpendytikisDapanis: '',
      kostosAgoras: totalKostosAgoras,
      isSummaryRow: true,
    },
  ];

  return (
    <div>
       <>
            <p className="mt-4 mr-0 color-blue-3 text-bold font-size-24">
              Χρηματοδοτικό Σχήμα Επένδυσης
            </p>
              <Col span={24}>
                <div>
                  <DataTable
                    scroll={{ x: true }}
                    id="basicInfo-application-results-table"
                    className={`${!isEmpty(excelData)?'table-with-totals-purple':'table-with-totals-purple table-no-data'}`}
                    columns={columnsInvestmentTotalAmountTable}
                    dataSource={testSelectedDataTable}
                    rowKey="id"
                    // pagination={{
                    //   showSizeChanger: false,
                    //   showTitle: false,
                    // }}
                    pagination={false}
                  />
                </div>
              </Col>
              </>
     
    </div>
  );
};

export default SubTabPlan4;
